import React from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { Link } from "react-router-dom";
import "./InvestmentAbout.css";

const InvestmentAbout = () => {
  const { translations: tRaw } = useLanguage();
  const t = {
    investment: {},
    ...tRaw,
    investment: { ...tRaw?.investment },
  };

  return (
    <section id="investment-about" className="investment-about-section">
      <motion.div
        className="investment-about-container"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.h2 
          className="investment-about-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {t.investment?.aboutTitle || "Investment Opportunity in iWinto"}
        </motion.h2>
        
        <div className="investment-details-grid">
          <motion.div 
            className="investment-detail-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <h3>{t.investment?.about?.aboutIwinto || "About iWinto"}</h3>
            <p>
              {t.investment?.about?.aboutIwintoText || "iWinto is a revolutionary digital application transforming the relationship between users and daily offers, incentives, and digital services. It combines e-commerce, social communication, and marketing in a participatory model that delivers rewarding digital experiences for individuals and businesses."}
            </p>
          </motion.div>

          <motion.div 
            className="investment-detail-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <h3>{t.investment?.about?.projectValuation || "Project Valuation"}</h3>
            <p>
              <strong>AED 50,000,000</strong> (Fifty Million UAE Dirhams)
              <br /><br />
              {t.investment?.about?.projectValuationText || "The project has been evaluated based on technical, commercial, and technical standards."}
            </p>
          </motion.div>

          <motion.div 
            className="investment-detail-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            <h3>{t.investment?.about?.operationalTargets || "Operational Targets"}</h3>
            <ul>
              {t.investment?.about?.targets?.map((target, index) => (
                <li key={index}>{target}</li>
              )) || [
                "500,000 active users within first 6 months",
                "3 million active users within first 2 years",
                "Expand to hundreds of retail sectors",
                "Develop AI tools for user behavior analysis"
              ].map((target, index) => (
                <li key={index}>{target}</li>
              ))}
            </ul>
          </motion.div>
        </div>
        
        <motion.p 
          className="investment-about-text"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.7, duration: 0.6 }}
        >
          {t.investment?.about?.aboutText || "iWinto targets the Gulf market, Middle East, and North Africa with expansion plans to global markets. The technical infrastructure is complete with support from a technical, administrative, and marketing team, along with local and international strategic partners."}
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          <Link 
            to="/about" 
            className="investment-about-link"
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 8px 25px rgba(0, 136, 255, 0.3)"
            }}
            whileTap={{ scale: 0.95 }}
          >
            {t.investment?.aboutLink || "Learn More About Investment Opportunities"}
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default InvestmentAbout;